import { render, staticRenderFns } from "./marketMap.vue?vue&type=template&id=f57a65dc&scoped=true&"
import script from "./marketMap.vue?vue&type=script&lang=js&"
export * from "./marketMap.vue?vue&type=script&lang=js&"
import style0 from "./marketMap.vue?vue&type=style&index=0&id=f57a65dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57a65dc",
  null
  
)

export default component.exports